import { render, staticRenderFns } from "./Productwhitelist.vue?vue&type=template&id=71a1059c&scoped=true&"
import script from "./Productwhitelist.vue?vue&type=script&lang=js&"
export * from "./Productwhitelist.vue?vue&type=script&lang=js&"
import style0 from "./Productwhitelist.vue?vue&type=style&index=0&id=71a1059c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a1059c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a1059c')) {
      api.createRecord('71a1059c', component.options)
    } else {
      api.reload('71a1059c', component.options)
    }
    module.hot.accept("./Productwhitelist.vue?vue&type=template&id=71a1059c&scoped=true&", function () {
      api.rerender('71a1059c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Selected-products/Productwhitelist.vue"
export default component.exports